import type { AnchorHTMLAttributes } from 'react';

// Storefront pages are real HTML documents; normal links also work without JS.
export default function Link({
  prefetch: _prefetch,
  ...props
}: AnchorHTMLAttributes<HTMLAnchorElement> & { prefetch?: boolean }) {
  return <a {...props} />;
}
